import { GetterTree } from 'vuex';
import { State } from './errors.store';

const getters: GetterTree<State, State> = {
  getCurrentErrorName: state => {
    return state.currentEventItem.errorLog.message;
  },
  getCurrentEventID: state => {
    return state.currentEventID;
  },
  getEventCount: state => {
    return state.currentEventItem.events ? state.currentEventItem.events : 0;
  }
};
export default getters;
